
import { Vue, Component, Prop } from "vue-property-decorator";

import FadeOverlay from "@/components/common/FadeOverlay.vue";
import PriceCardViewTitle from "@/components/payment/prices/PriceCardViewTitle.vue";
import SubscriptionPeriod from "@/components/payment/prices/SubscriptionPeriod.vue";

import PriceCardViewPricing from "./PriceCardViewPricing.vue";
import { SubscriptionStatus } from "@/entities/payment/SubscriptionStatus";
import { Subscription, Subscription_Plan } from "@/generated/graphql";

@Component({
  components: {
    PriceCardViewTitle,
    PriceCardViewPricing,
    FadeOverlay,
    SubscriptionPeriod,
  },
})
export default class PriceCardView extends Vue {
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: String, required: true }) readonly price!: string;
  @Prop({ type: String, required: true }) readonly slogan!: string;
  @Prop({ type: Boolean, default: false }) readonly emphasized!: boolean;
  @Prop({ type: Boolean, default: false }) readonly benefitsShown!: boolean;
  @Prop({ type: String, default: undefined }) readonly subscriptionPlanId?: string;
  @Prop({ type: String, default: undefined }) readonly label?: string;
  @Prop({ type: Object, default: undefined }) readonly currentSubscription?: Subscription;
  @Prop({ type: Number, default: undefined }) readonly managersCount?: number;
  @Prop({ type: Number, default: 0 }) readonly activeManagersCount!: number;
  @Prop({ type: Array, required: true }) readonly generalSubscriptionPlans!: string[];
  @Prop({ type: Boolean, required: true }) readonly checkIfPlanIsPremium!: boolean;


  get shouldNotShowSlot(): boolean {
    const premiumPlusNewPLansInnerNames = [
      'PREMIUMPLUSFIVE',
      'PREMIUMPLUSTEN',
      'PREMIUMPLUSFIFTEEN',
      'PREMIUMPLUSTWENTY',
      'PREMIUMPLUSTWENTYFIVE',
      'PREMIUMPLUSTHIRTY',
      'PREMIUMPLUSTHIRTYFIVE',
      'PREMIUMPLUSFORTY',
      'PREMIUMPLUSFORTYFIVE',
      'PREMIUMPLUSFIFTY',
    ];

    return premiumPlusNewPLansInnerNames.includes(this.currentSubscription?.subscription_plan.inner_name);
  }

  get cancelAtPeriodEnd(): boolean {
    return Boolean(this.currentSubscription?.cancel_at_period_end);
  }

  get isPastDueStatus(): boolean {
    return this.currentSubscription!.status === SubscriptionStatus.PAST_DUE;
  }

  get status(): string {
    if (!this.isCardActive) {
      return "";
    }

    return this.currentSubscription!.status!;
  }

  get disabledCardMessage(): string {
    const countMessage = this.managersCount === 1 ? "manager" : "managers";
    return `It allows access to ${this.managersCount} ${countMessage}, but you have access to ${this.activeManagersCount}`;
  }

  get cardLabel(): string | undefined {
    if (this.cardDisabled) {
      return "Can not be selected";
    }
   
    return this.label;
  }

  // get cardDisabled(): boolean {
  //   if (!this.managersCount) {
  //     return false;
  //   }
  //   return this.activeManagersCount > this.managersCount;
  // }

  get cardDisabled(): boolean {
    if (!this.managersCount || (this.shouldNotShowSlot && this.checkIfPlanIsPremium)) {
      return false;
    }

    return this.activeManagersCount > this.managersCount;
  }

  get periodEnd(): number {
    const endDate = this.currentSubscription?.current_period_end;
    if (endDate) {
      return endDate;
    }
    return 0;
  }

  get isCardActive(): boolean {
    if (!this.currentSubscription) {
      return false;
    }
    return this.currentSubscription.subscription_plan_id === this.subscriptionPlanId || (this.shouldNotShowSlot && this.checkIfPlanIsPremium);
  }


  get cardStyles(): Record<string, boolean> {
    return {
      "bg-gray-50": this.emphasized,
      "border-primary-500": this.isCardActive ,
    };
  }

  get isCurrentSubscription(): boolean {
    return this.subscriptionPlanId === this.currentSubscription?.subscription_plan_id;
  }


}
